import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { Rating, type RatingProps } from 'base-ui'

import { ProductSearchRefinementRatingInputRatingIconContainer } from './ProductSearchRefinementRatingInputRatingIconContainer'

import styles from './ProductSearchRefinementRatingInputRating.module.css'

export const ProductSearchRefinementRatingInputRating: FC<RatingProps> = (
  props,
) => {
  const intl = useIntl()

  return (
    <div
      className={styles['product-search-refinement-rating-input-rating']}
      data-qa-id="product-rating"
    >
      <Rating
        {...props}
        getLabelText={(value) =>
          intl.formatMessage(
            { id: 'searchResults.label.rating.stars' },
            { value },
          )
        }
        slots={{
          iconContainer: ProductSearchRefinementRatingInputRatingIconContainer,
        }}
      />
    </div>
  )
}
